import { useState, useEffect } from "react";
import ModalNovoInsumo from "../components/ModalNovoInsumo";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import { Trash2, Pencil, Plus } from "lucide-react";
import { handleError } from "../services/handleError";
import Loading from "./Loading";
import axiosInstance from "../axiosConfig";

export default function InsumosPage() {
    const [insumos, setInsumos] = useState([]);
    const [selectedInsumo, setSelectedInsumo] = useState(null);
    const [insumoParaExcluir, setInsumoParaExcluir] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        buscarInsumos();
    }, []);

    async function buscarInsumos() {
        setLoading(true);

        try {
            const response = await axiosInstance.get("Insumos");

            setInsumos(response.data);
        } catch (error) {
            handleError(error, "Erro ao buscar estoque.");
        } finally {
            setLoading(false);
        }
    }

    const handleSave = async (insumo) => {
        try {
            if (insumo.id) {
                await axiosInstance.put(`Insumos/${insumo.id}`, insumo);
            } else {
                await axiosInstance.post("Insumos", insumo);
            }

            setInsumos((prev) => {
                const existe = prev.find((i) => i.id === insumo.id);
                if (existe) {
                    return prev.map((i) => (i.id === insumo.id ? insumo : i));
                }
                return [...prev, insumo];
            });

            setSelectedInsumo(null);
        } catch (error) {
            handleError(error, "Erro ao salvar insumo.");
        }
    };

    const handleDeleteConfirm = async () => {
        if (!insumoParaExcluir) return;

        try {
            await axiosInstance.delete(`Insumos/${insumoParaExcluir.id}`);

            setInsumos((prev) => prev.filter((i) => i.id !== insumoParaExcluir.id));
            setInsumoParaExcluir(null);
        } catch (error) {
            handleError(error, "Erro ao excluir insumo:");
        }
    };

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="p-6">
            <div className="flex items-center justify-between mb-6">
                <h1 className="text-2xl font-bold text-gray-800">Gerenciar Insumos</h1>
                <button
                    className="flex items-center gap-2 bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-blue-700 transition"
                    onClick={() => setSelectedInsumo(1)}
                >
                    <Plus size={16} />
                    Novo Insumo
                </button>
            </div>

            <div className="overflow-auto border rounded-md">
                <table className="min-w-full text-sm">
                    <thead className="bg-gray-100 text-gray-700">
                        <tr>
                            <th className="text-left p-3">Nome</th>
                            <th className="text-left p-3">Unidade</th>
                            <th className="text-left p-3">Alerta</th>
                            <th className="text-right p-3">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {insumos.map((insumo, idx) => (
                            <tr key={insumo.id} className={`${idx % 2 === 0 ? "bg-white" : "bg-gray-50"} border-t hover:bg-gray-50`}>
                                <td className="p-3 font-medium text-gray-800">{insumo.nome}</td>
                                <td className="p-3">{insumo.unidade}</td>
                                <td className="p-3">{insumo.quantidadeMinima} {insumo.unidade}</td>
                                <td className="p-3 text-right flex justify-end gap-2">
                                    <button
                                        onClick={() => setSelectedInsumo(insumo)}
                                        className="text-blue-600 hover:text-blue-800"
                                    >
                                        <Pencil size={18} />
                                    </button>
                                    <button
                                        onClick={() => setInsumoParaExcluir(insumo)}
                                        className="text-red-600 hover:text-red-800"
                                    >
                                        <Trash2 size={18} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {insumos.length === 0 && (
                            <tr>
                                <td colSpan="5" className="p-4 text-center text-gray-500">
                                    Nenhum insumo cadastrado.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {selectedInsumo !== null && (
                <ModalNovoInsumo
                    isOpen={!!selectedInsumo}
                    onClose={() => setSelectedInsumo(null)}
                    onSave={handleSave}
                    initialData={selectedInsumo}
                />
            )}

            <ConfirmDeleteModal
                isOpen={!!insumoParaExcluir}
                onClose={() => setInsumoParaExcluir(null)}
                onConfirm={handleDeleteConfirm}
                itemName={insumoParaExcluir?.nome}
            />
        </div>
    );
}